import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVSunEditor } from "../../shared/JVSuneditor";
import { IEmail } from "./Inbox";

interface IComposeEmail {
    id?: number
    subject?: string
    body?: string
    to?: string
    cc?: string
    bcc?: string
}

interface Iprops {
    singleData: IComposeEmail,
    onSend: (data: IEmail) => void,
    open: boolean,
    hideDialog: () => void,
    toast: any
}

export const Compose = (props: Iprops) => {
    const [body, setBody] = useState("");
    const [loading, setLoading] = useState(false);

    const schema = yup.object({
        to: yup.string().required("To is required*"),
        cc: yup.string().nullable(),
        bcc: yup.string().nullable(),
        subject: yup.string().required("Subject is required*"),
        body: yup.string().nullable()
    });

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IComposeEmail>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });
    useEffect(() => {
        reset(props.singleData);
        if (props.singleData.body)
            setBody(props.singleData.body);
    }, [props.singleData])

    const sendEmail = async (data: IComposeEmail) => {
        setLoading(true);
        data.body = body;
        const response = await Fetch("email/send", 'POST', data, null, props.toast);

        if (response) {
            const data = await response.json();
            props.onSend(data);
            onHide();
            props.toast.current.show({ severity: 'success', detail: "Send Successfully", life: 3000 });
        }
        setLoading(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
        setBody("");
    }

    function onSubmit(data: IComposeEmail) {
        if (body.length < 1) props.toast.current.show({ severity: 'error', detail: "Body is Required.", life: 3000 });
        else sendEmail(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Send Email" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput required label="To" control={control} name="to" error={errors.to?.message} />
                <JVInput label="Cc" control={control} name="cc" error={errors.cc?.message} />
                <JVInput column={1} label="Bcc" control={control} name="bcc" error={errors.bcc?.message} />
                <JVInput column={1} required label="Subject" control={control} name="subject" error={errors.subject?.message} />
                <div className="col-12 md:col-12 md:col-6 mb-3">
                    <label htmlFor="tbody">Body</label>
                    <JVSunEditor name="template_Body" value={body} handleChange={setBody} />
                </div>

                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button loading={loading} style={{ width: '100px' }} label="SEND" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CANCLE" onClick={onHide} type="button" className="p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}
